import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './App.css';
import LaserFlow from './LaserFlow';
import config from './config';

function Success() {
  const [sessionData, setSessionData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const sessionId = queryParams.get('session_id');

    if (!sessionId) {
      // No session ID, redirect to home
      navigate('/', { replace: true });
      return;
    }

    // Fetch session data
    fetch(`${config.apiUrl}/session-status?session_id=${sessionId}`)
      .then(res => res.json())
      .then(data => {
        setSessionData(data);
      })
      .catch(err => {
        console.error('Error fetching session:', err);
        navigate('/', { replace: true });
      });
  }, [navigate]);

  const handleReturnHome = () => {
    // Set flag to show time slots page after successful payment
    sessionStorage.setItem('showTimeSlots', 'true');
    sessionStorage.setItem('userEmail', sessionData?.customer_email || 'user@email.com');
    navigate('/', { replace: true });
  };

  return (
    <div className="app" style={{ background: '#000', position: 'relative', overflow: 'hidden' }}>
      <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 1 }}>
        <LaserFlow
          horizontalBeamOffset={0.0}
          verticalBeamOffset={0.1}
          color="#9D1515"
          wispDensity={0.8}
          wispIntensity={4.0}
          fogIntensity={0.4}
          flowStrength={0.2}
        />
      </div>

      <div className="logo-container-small" style={{ zIndex: 20 }}>
        <img 
          src={'/ovr-logo.png'}
          alt="Ottawa Volleyball Revival" 
          className="logo-small"
        />
      </div>

      <div className="success-container">
        <div className="success-content">
          <h1 className="success-title">🏐 PAYMENT SUCCESSFUL!</h1>
          <p className="success-message">
            Thank you for registering!
          </p>
          {sessionData && sessionData.metadata && (
            <div className="success-details">
              <p><strong>Time Slot:</strong> {sessionData.metadata.timeSlot}</p>
              <p><strong>Player Type:</strong> {sessionData.metadata.playerType}</p>
              {sessionData.metadata.teamName && (
                <p><strong>Team Name:</strong> {sessionData.metadata.teamName}</p>
              )}
              <p><strong>Number of Players:</strong> {sessionData.metadata.numPlayers}</p>
              <p><strong>Total Paid:</strong> ${(parseInt(sessionData.metadata.numPlayers) * 5).toFixed(2)} CAD</p>
            </div>
          )}
          <p className="success-email">
            A confirmation email has been sent to your inbox.
          </p>
          <button onClick={handleReturnHome} className="team-form-btn" style={{ marginTop: '30px' }}>
            RETURN HOME
          </button>
        </div>
      </div>
    </div>
  );
}

export default Success;

